module.exports = __webpack_public_path__ + "ec8451e974b43970b14f10ed78f45f57.png";